import { errorHandler } from "src/app/util/errorHandler";
import { authData, removeAuth, saveAuth } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { DataService } from "src/app/http/data.service";

@Component({
  selector: "app-switch-profile",
  templateUrl: "./switch-profile.component.html",
})
export class SwitchProfileComponent implements OnInit {
  constructor(private httpClient: HttpClient, 
    private router: Router,
    private dataService: DataService) {}

  loading = false;
  notification = {};
  wards : any[] = [];
  _auth = authData();
  skeletonLoader = false;
  payload = {
    StudentNo: this._auth.Matric,
    Password: this._auth.Student.FamilyID,
    AuthToken: ""
  };

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this._auth.Token,
    }),
  };

  ngOnInit(): void {
    this.getWards();
  }

  getWards() {
    if (!this._auth.IsFamilyLogin) {
      this.router.navigateByUrl("/");
    }
    this.skeletonLoader = true;
    this.loading = true;
    const baseUrl = `${environment.BASE_URL}/users/getWards`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        if (res.Success) {
          this.wards = res.Data.Wards || [];
          this.payload.AuthToken = res.Data.AuthToken || [];
        } else {
          this.notification = {
            error: true,
            message: res.Message || "An error occurred.",
          };
        }
        this.skeletonLoader = false;
        this.loading = false;
      },
      (err) => {
        this.skeletonLoader = false;
        this.loading = false;
        this.notification = errorHandler(err);
      }
    );
  }
  switchWard() {
    this.loading = true;
    const baseUrl = `${environment.BASE_URL}/users/SwitchStudent`;
    this.httpClient
      .post(baseUrl, this.payload, this.httpOptions)
      .subscribe({
        next: (res: any) => {
          if (res.Success) {
            removeAuth();
            this.dataService.clearPassportData();
            
            saveAuth({ ...res?.Data, Matric: res?.Data.Student.StudentNo });
  
            this.router.navigateByUrl(res?.Data?.ResetPassword ? "/reset-password" : "/");
          } else {
            this.notification = {
              error: true,
              message: res.Message || "An error occurred.",
            };
          }
        },
        error: (err: any) => {
          this.notification = errorHandler(err);
        },
      })
      .add(() => {
        this.loading = false;
        saveAuth([], "_courses");
        saveAuth({}, "_checks");
        saveAuth(null, "_news");
        saveAuth(null, "_deadlines");
        saveAuth([], "_accommodation");
        saveAuth([], "_slider");
        saveAuth([], "_requirements");
        saveAuth({}, "_passport");
        saveAuth(false, "_isApplication");
      });
  }
}
